var exports = {
  "h_": "GiftSendToFriendModal.module__description___UGZERW",
  "jo": "GiftSendToFriendModal.module__sendButton___UGZERW",
  "Zw": "GiftSendToFriendModal.module__giftCodeText___UGZERW",
  "A4": "GiftSendToFriendModal.module__giftCode___UGZERW",
};

module.exports = exports;
